import intlMessagesEN from './i18n/localization/en.json';
import intlMessagesVi from './i18n/localization/vi.json';
import initReducer from './Store/initReducer';

export default {
  name: 'Authenticate',
  dir: 'Authenticate',
  pathRoot: '',
  routes: [
    {
      url: '',
      component: 'Page/index',
      layout: 'BlankLayout',
      meta: {
        authRoute: true,
      },
      props: {
        title: 'Đăng nhập | Smart Event',
        titleI18n: 'Auth:title',
        exact: true,
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: false,
  initRedux: initReducer,
};
